import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import NewEventModal from './NewEventModal';
import { APP_VERSION } from '../utils/version';

// Mobile (APK) shell: compact top bar (menu · event picker · avatar), slide-in
// drawer with the full menu, and a bottom tab bar for the main screens.
export default function LayoutMobile({ vm }) {
  const {
    user, roleLabel, isSuperAdmin, isViewingAs, initials, fullName, shellClass,
    visibleNav, bottomNav, navIcon, events, event, onEventChange,
    drawerOpen, setDrawerOpen, theme, toggleTheme,
    viewAsOptions, onViewAsChange, returnToSuperAdmin,
    eventModalOpen, openEventModal, doLogout, forgetDevice, updateAvailable,
  } = vm;
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <div className={`${shellClass} shell-mobile`}>
      <div className="topbar">
        <button className="iconbtn hamburger" onClick={() => setDrawerOpen(true)} aria-label="Menu">☰</button>
        <div className="topbar-pickers" style={{ flex: 1, minWidth: 0 }}>
          <select value={event?.EventId ?? ''} onChange={(e) => onEventChange(e.target.value)} title="Event" style={{ width: '100%' }}>
            <option value="">Select event</option>
            {events.map(e => <option key={e.EventId} value={e.EventId}>{e.EventName}</option>)}
          </select>
        </div>
        {isSuperAdmin && <button className="iconbtn add-event" onClick={openEventModal} title="Add event">+</button>}
        <NavLink to="/app/profile" className="avatar" style={{ marginLeft: 6 }} title={fullName}>{initials}</NavLink>
        {/* Build version — top right, so a tester can say which build they are on. */}
        <span className="app-version" title={updateAvailable ? `Mehfil ${APP_VERSION} — a newer version is on the Play Store` : `Mehfil ${APP_VERSION}`}>
          v{APP_VERSION}{updateAvailable && <span className="app-update-dot"> ⬆</span>}
        </span>
      </div>
      {isViewingAs && (
        <div className="viewing-as-bar">
          Viewing as <strong>{fullName}</strong>
          <button type="button" className="btn light sm" onClick={returnToSuperAdmin}>Return</button>
        </div>
      )}

      <div className="body-wrap">
        <main className="content"><Outlet /></main>
      </div>

      {drawerOpen && (
        <div className="drawer-back" onClick={closeDrawer}>
          <nav className="drawer" onClick={(e) => e.stopPropagation()}>
            <NavLink to="/app/profile" className="navhead" onClick={closeDrawer}>
              <div className="avatar">{initials}</div>
              <div style={{ minWidth: 0 }}>
                <div className="navhead-name">{fullName}</div>
                <div className="navhead-sub">#{user?.UserId} - {user?.MobileNumber || '-'}</div>
                <div className="navhead-sub">{roleLabel}</div>
              </div>
            </NavLink>
            {visibleNav.map(n => (
              <NavLink key={n.to} to={n.to} onClick={closeDrawer} className={({ isActive }) => isActive ? 'active' : ''}>
                <span className="ic">{navIcon(n)}</span>
                {n.label}
              </NavLink>
            ))}
            {isSuperAdmin && (
              <label className="navlink-btn" style={{ display: 'block' }}>
                <span className="muted" style={{ fontSize: 12 }}>View as user</span>
                <select value="" onChange={(e) => { onViewAsChange(e.target.value); closeDrawer(); }}
                  style={{ width: '100%', marginTop: 4, padding: '8px 10px', border: '1px solid var(--line)', borderRadius: 8 }}>
                  <option value="">Pick a user…</option>
                  {viewAsOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </label>
            )}
            <div style={{ flex: 1 }} />
            <button type="button" className="navlink-btn" onClick={() => { toggleTheme(); closeDrawer(); }}>
              {theme === 'dark' ? '☀ Light Mode' : '🌙 Dark Mode'}
            </button>
            <NavLink to="/app/profile" onClick={closeDrawer} className={({ isActive }) => isActive ? 'active' : ''}>Profile</NavLink>
            <button type="button" className="navlink-btn" onClick={() => { closeDrawer(); forgetDevice(); }}>Forget device</button>
            <button type="button" className="navlink-btn danger" onClick={() => { closeDrawer(); doLogout(); }}>Logout</button>
          </nav>
        </div>
      )}

      <nav className="bottomnav">
        {bottomNav.map(n => (
          <NavLink key={n.to} to={n.to} className={({ isActive }) => isActive ? 'active' : ''}>
            <span className="ic">{navIcon(n)}</span>
            <span>{n.short || n.label}</span>
          </NavLink>
        ))}
      </nav>

      {eventModalOpen && <NewEventModal vm={vm} />}
    </div>
  );
}
